import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import Modal from "@/common/elements/Modal";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { isNonEmptyVariable } from "@/util/common_function";
import { Button, Form } from "antd";
import { useEffect } from "react";

export const MODE = {
  NEW: "new",
  EDIT: "edit",
};

const ActivityLogModal = ({
  show,
  handleCancel,
  formSubmit,
  selectActivity = null,
  bookingsFieldsEnabled = true
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isNonEmptyVariable(selectActivity)) {
      form.setFieldsValue(selectActivity);
    } else {
      form.resetFields();
    }
  }, [selectActivity]);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      const data = {
        ...values,
        startDate: isNonEmptyVariable(values?.startDate)
          ? values?.startDate?.format("MM/DD/YYYY")
          : null,
        endDate: isNonEmptyVariable(values?.endDate)
          ? values?.endDate?.format("MM/DD/YYYY")
          : null,
      };
      formSubmit(data);
      form.resetFields();
    });
  };
  function handleFormCancel() {
    form.resetFields();
    handleCancel()
  }
  return (
    <>
      <Modal
        show={show}
        header={`${selectActivity ? "VIEW" : "ADD"} Activity Log`}
        onHide={handleFormCancel}
        handleCancel={handleFormCancel}
        handleSubmit={handleSubmit}
        designPattern="ant"
        width="60%"
        footerActions={[
          <Button key="SUBMIT" onClick={handleFormCancel} disabled={!bookingsFieldsEnabled}>
            Close
          </Button>,
          <Button key="SUBMIT" onClick={handleSubmit} disabled={!bookingsFieldsEnabled}>
            Submit
          </Button>
        ]
        }
      // submitButtonDisabled={!bookingsFieldsEnabled}
      >
        <Form form={form} disabled={!bookingsFieldsEnabled}>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol span={24}>
              <FormItem label="Activity" name="activityType">
                <TextField id="activity" />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>

          <StyledGridRow gutter={[16]}>
            <StyledGridCol span={8}>
              <FormItem label="Start Date" name="startDate">
                <CommonDatePicker
                  placeholder={"Start Date"}
                  showTime={false}
                  format="MM/DD/YYYY"
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={8}>
              <FormItem label="End Date" name="endDate">
                <CommonDatePicker
                  placeholder={"End Date"}
                  showTime={false}
                  format="MM/DD/YYYY"
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={8}>
              <FormItem
                name="hoursAffected"
                label="Hours Affected"
                rules={[
                  {
                    type: 'number',
                    min: 1,
                    max: 24,
                    transform: (value) => Number(value),
                    message: 'Hours must be between 1 and 24',
                  }
                ]}
              >
                <TextField type="number" id="hoursAffected" />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol span={24}>
              <FormItem name="comment" label="Comment">
                <TextField inputType="textarea" id="comment" rows={5} />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </Form>
      </Modal>
    </>
  );
};

export default ActivityLogModal;
